export default __webpack_public_path__ + "static/media/Samahdi-logo1.fac7a704.png";